import orgHttps from '../init/orgHttps';

//ORG-ACT-01 : Populate the information on activity dashboard
export async function orgActdashFun() {
    const result = await orgHttps.get(`/org/act`);
    return result;
}

//ORG-ACT-02 : Register a new activity organizer
export async function orgActRegisterFun(data) {
    const result = await orgHttps.post(`org/act/register`, data);
    return result;
}

//ORG-ACT-03 : Gives the list of booked customers for given activity
export async function orgActBookedOnDate(guidTourId, date) {
    const result = await orgHttps.get(`/org/act/booked/${guidTourId}/${date}`);
    return result;
}

//ORG-ACT-04 : Get OTP to register a new activity organizer
export async function orgActRegOTP(data, method) {
    const result = await orgHttps.post(`org/act/register/otp?method=${method}`, data);
    return result;
}

//ORG-ACT-05 list of activities of particular organizer
export async function orgActPackListFun(status, limit, offset) {
    const result = await orgHttps.get(`/org/act/acts?status=${status}&limit=${limit}&offset=${offset}`);
    return result;
}

//ORG-ACT-06 count packages of particular organizer
export async function orgActivitiesCount(status) {
    const result = await orgHttps.get(`/org/act/count/acts?status=${status}`);
    return result;
}

//ORG-ACT-07 : To get complete content of activity for organizer
export async function orgActDetailsFun(actId) {
    const result = await orgHttps.get(`/org/act/details/act/${actId}`);
    return result;
}

//ORG-ACT-08 : To add new activity details
export async function actCreateFun(data) {
    const result = await orgHttps.post(`org/act/create`, data);
    return result;
}

//ORG-ACT-09 : To add new booking manually
export async function actDateMnFun(data) {
    const result = await orgHttps.post(`org/act/manual`, data);
    return result;
}
//ORG-ACT-10 Edit activity when its active
export async function orgActiveActEdit(packId, data) {
    const result = await orgHttps.patch(`org/act/active/${packId}`, data);
    return result;
}

//ORG-ACT-11 Edit activity when its inactive
export async function orgInactiveActEdit(packId, data) {
    const result = await orgHttps.put(`org/act/inactive/${packId}`, data);
    return result;
}

// ORG-ACT-12 List of booking for particular organizer
export async function orgActBookingList(date, limit, offset, tourid) {
    const result = await orgHttps.get(
        `/org/act/booked/list?date=${date}&limit=${limit}&offset=${offset}&actid=${tourid}`
    );
    return result;
}

// ORG-ACT-13 Count of booking for particular organizer
export async function orgActBookingCount(date, tourid) {
    const result = await orgHttps.get(`/org/act/count/booked?date=${date}&tourid=${tourid}`);
    return result;
}

// ORG-ACT-14 Dropdowns for activity list in page bookings and Reviews
export async function orgActListData() {
    const result = await orgHttps.get(`/org/act/packs/list/dropdown`);
    return result;
}

//ORG-ACT-15 : Count of billing entries for the activity organizer
export async function orgActBillingCount(status, approval) {
    const result = await orgHttps.get(`/org/act/count/billing?status=${status}&approval=${approval}`);
    return result;
}

//ORG-ACT-16 : List of billing/payouts for the activity organizer
export async function orgActBillingData(status, approval, limit, offset) {
    const result = await orgHttps.get(
        `/org/act/billing?status=${status}&approval=${approval}&limit=${limit}&offset=${offset}`
    );
    return result;
}

//ORG-ACT-17 : List of payouts for the activity organizer
export async function orgActPayouts(limit, offset) {
    const result = await orgHttps.get(`/org/act/payouts?limit=${limit}&offset=${offset}`);
    return result;
}

//ORG-ACT-18 : Count of payouts for the activity organizer
export async function orgActPayoutsCount() {
    const result = await orgHttps.get(`/org/act/count/payouts`);
    return result;
}

//ORG-ACT-19 : Details of a particular activity payout
export async function orgActPayoutsMoreData(id) {
    const result = await orgHttps.get(`org/act/payout/details/${id}`);
    return result;
}

//ORG-ACT-20 : Cancel a single activity booking
export async function orgBookingCancelFun(data) {
    const result = await orgHttps.patch(`org/act/cancel/each/booking`, data);
    return result;
}

//ORG-ACT-21 : Activity organizer dashboard data
export async function orgActDashboardData(date = 'next', bookingsOnly = true, offset = 0, limit = 10) {
    return await orgHttps.get(
        `/org/act/dashboard?date=${date}&bookingsOnly=${bookingsOnly}&offset=${offset}&limit=${limit}`
    );
}

//ORG-ACT-22 : List of bookings for a particular activity slot
export async function orgActSlotBookings(actDatesId, slotId, offset = 0, limit = 10) {
    return await orgHttps.get(`/org/act/dashboard/${actDatesId}/${slotId}/bookings?offset=${offset}&limit=${limit}`);
}

//ORG-ACT-23 : Get dates for an activity
export async function orgActDates(actid, dateType, offset, limit) {
    const result = await orgHttps.get(`/org/act/date/${actid}`, {
        params: {
            date: dateType,
            offset,
            limit
        }
    });
    return result;
}

//ORG-ACT-24 : Add a new time slot to an activity date
export async function orgAddTimeSlot(id, type, data) {
    return await orgHttps.post(`/org/act/date/${id}`, data);
}

//ORG-ACT-25 : Edit an activity slot
export async function orgUpdateActivitySlot(dateId, slotId, data) {
    return await orgHttps.patch(`/org/act/date/${dateId}/slot/${slotId}`, data);
}

//ORG-ACT-26 : Delete an activity slot
export async function orgDeleteActivitySlot(dateId, type, slotId) {
    return await orgHttps.delete(`/org/act/date/${dateId}/slot/${slotId}`);
}

//ORG-ACT-27 : Delete an activity date
export async function orgDeleteActivityDate(dateId) {
    return await orgHttps.delete(`/org/act/delete/date/${dateId}`);
}
